import AssociationsField from '../shared/components/associations-field';
import ComponentManager from '../shared/component-manager';
import OrganizationField from '../shared/components/organization-field';

import InternshipForm from './components/mentor/internship-form';
import InternshipTypeSelector from './components/mentor/internship-type-selector';
import MentorDisponibilityForm from './components/mentor/mentor-disponibility-form';
import MentorshipRequest from './components/mentor/mentorship-request';
import MentorshipRatingList from './components/mentor/mentorship-rating-list';
import TopBannerApp from './components/top-banner-app';
import PopDropfilterForm from './components/mentor/pop-dropfilter-form';
import MinorityGroupsManager from './components/mentor/mentor-groups-manager';

class MentorComponentManager extends ComponentManager {
  initializeComponents() {
    AssociationsField.initialize('.associationsField');
    InternshipForm.initialize('.internshipForm');
    InternshipTypeSelector.initialize('.internshipTypeSelector');
    MentorDisponibilityForm.initialize('.mentorDisponibilityForm');
    MentorshipRequest.initialize('.mentorshipRequest');
    MentorshipRatingList.initialize('.mentorshipRatings');
    OrganizationField.initialize('.organizationField');
    TopBannerApp.initialize('.topBannerApp');
    PopDropfilterForm.initialize('.popDropfilterForm');
    MinorityGroupsManager.initialize('.minority-groups-manager');
  }
}

export const initialize = () => {
  jQuery(() => {
    new MentorComponentManager([
      InternshipForm,
      InternshipTypeSelector,
      MentorDisponibilityForm,
      MentorshipRequest,
      MentorshipRatingList,
      TopBannerApp,
      PopDropfilterForm,
      MinorityGroupsManager,
    ]);
  });
};
